// extracted by mini-css-extract-plugin
export default {"cls1":"zd8w7DhcxZY45MY4d1IU","cls2":"aLoXG8ugnQJqLGpvp6cQ zd8w7DhcxZY45MY4d1IU"};